__turbopack_context__.v({
  "avatar": "public-boat-card-module-scss-module__1k_X0a__avatar",
  "boatModel": "public-boat-card-module-scss-module__1k_X0a__boatModel",
  "boatModelIcon": "public-boat-card-module-scss-module__1k_X0a__boatModelIcon",
  "boatModelTitle": "public-boat-card-module-scss-module__1k_X0a__boatModelTitle",
  "card": "public-boat-card-module-scss-module__1k_X0a__card",
  "cardWrapper": "public-boat-card-module-scss-module__1k_X0a__cardWrapper",
  "cover": "public-boat-card-module-scss-module__1k_X0a__cover",
  "flag": "public-boat-card-module-scss-module__1k_X0a__flag",
  "like": "public-boat-card-module-scss-module__1k_X0a__like",
  "stats": "public-boat-card-module-scss-module__1k_X0a__stats",
  "statsItem": "public-boat-card-module-scss-module__1k_X0a__statsItem",
  "statsShadow": "public-boat-card-module-scss-module__1k_X0a__statsShadow",
  "title": "public-boat-card-module-scss-module__1k_X0a__title",
  "titleContainer": "public-boat-card-module-scss-module__1k_X0a__titleContainer",
});
